import React from 'react';
import {ErrorMessage} from 'formik';
import {Col, Input, Typography} from 'antd';
import {fieldColProps, labelStyle} from '../gridHelpers';

const TextareaBox = (props) => {
  const {formikProp} = props;
  const textareaField = props.field;
  const customEvents: any = props.customEvents
    ? props.customEvents[textareaField.name] && props.customEvents[textareaField.name]
    : {};

  return (
    <Col {...fieldColProps(textareaField)}>
      <Typography.Text style={labelStyle}>{textareaField.fieldLabel}</Typography.Text>
      <Input.TextArea
        disabled={textareaField.isDisabled ?? false}
        readOnly={textareaField.readonly ?? false}
        rows={textareaField.rows}
        name={textareaField.name}
        value={formikProp.values[textareaField.name] ?? ''}
        onChange={(e) => {
          formikProp.setFieldValue(textareaField.name, e.target.value);
          customEvents &&
            customEvents.onChange &&
            customEvents['onChange'](e, formikProp.setFieldValue);
        }}
      />
      {textareaField.note && (
        <Typography.Text type="secondary">{textareaField.note}</Typography.Text>
      )}
      <ErrorMessage name={textareaField.name} component="div" />
    </Col>
  );
};

export default TextareaBox;
